export default "__VITE_ASSET__BQsSvaMk__"